import { Helmet } from "react-helmet";
import AboutOurProductBackgroundImg from "../../assets/img_frame_313733.webp";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import AboutOurProductSection from "./AboutOurProductSection";
import SolutionsOverviewSection from "./SolutionsOverviewSection";
import SolutionsSection from "./SolutionsSection";
import React from "react";

export default function SolutionsPage() {
  return (
    <>
      <Helmet>
        <title>Advanced Digital Twin Product Solutions - Zwilling Labs</title>
        <meta
          name="description"
          content="Discover Zwilling Labs' end-to-end Digital Twin Platform to revolutionize manufacturing. Connect data sources, visualize digital twins, and drive actionable insights with our smart factory solutions."
        />
      </Helmet>
      <div className="w-full bg-white">
      <Header className="rounded-bl-[34px] rounded-br-[34px] bg-gradient5" />
        {/* Hero Section */}
        <div className="flex items-center -mt-[34px] min-h-screen bg-gray-900_07 bg-cover bg-no-repeat md:h-auto" style={{ backgroundImage: `url(${AboutOurProductBackgroundImg}) `}}>
          <div className="flex flex-col items-center pt-[50px] gap-[116px] px-12 md:px-5 mb-[236px] md:mb-[180px] md:gap-[87px] sm:gap-[58px]">
            <AboutOurProductSection />
          </div>
        </div>

        {/* Solutions Overview Section */}
        <SolutionsOverviewSection />

        {/* Solutions Section */}
        <SolutionsSection />

        {/* Footer Section */}
        <Footer className="rounded-tl-[34px] rounded-tr-[34px] bg-gradient1 sm:py-[5%]" />
      </div>
    </>
  );
}
